import React, { useEffect, useState } from 'react';

// Load private photos with the same cookie session as the API, then render a
// local image URL. This avoids relying on embedded browsers' document handling
// for authenticated file responses. Never put access tokens in image URLs.
export default function VehicleImage({ path, alt, className = '' }) {
  const [attempt, setAttempt] = useState(0);
  const [image, setImage] = useState(null);
  const [failedPath, setFailedPath] = useState(null);
  useEffect(() => {
    const controller = new AbortController();
    let objectUrl;
    setImage(null);
    setFailedPath(null);
    async function load() {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/files/${path}`, {
          credentials: 'include', cache: 'no-store', signal: controller.signal,
        });
        if (!response.ok) throw new Error('Bild nicht verfügbar');
        const blob = await response.blob();
        if (!['image/jpeg', 'image/png', 'image/webp'].includes(blob.type)) throw new Error('Ungültiges Bildformat');
        if (controller.signal.aborted) return;
        objectUrl = URL.createObjectURL(blob);
        setImage({ path, url: objectUrl });
      } catch (error) {
        if (!controller.signal.aborted) setFailedPath(path);
      }
    }
    if (path) load();
    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path, attempt]);

  if (failedPath === path) return (
    <button type="button" className={`${className} flex flex-col items-center justify-center gap-2 min-h-24 text-sm text-[#525866]`}
      onClick={(event) => { event.preventDefault(); event.stopPropagation(); setAttempt(value => value + 1); }}
      aria-label={`Bild erneut laden: ${alt}`}>
      <span>Bild konnte nicht geladen werden</span><span className="underline">Erneut laden</span>
    </button>
  );
  if (image?.path === path) return <img src={image.url} alt={alt} className={className} onError={() => setFailedPath(path)} />;
  return <div className={`${className} animate-pulse bg-[#F1F2F4]`} role="status" aria-label="Fahrzeugbild wird geladen" />;
}
